import type { RouteRecordRaw } from "vue-router";

export const organizationRoutes: RouteRecordRaw[] = [
  {
    path: "/organizations",
    name: "organizations",
    component: () => import("../presentation/pages/Organizations.vue"),
    meta: {
      action: "list",
      subject: "organization",
      layout: "default",
    },
  },
  {
    path: "/current-organization",
    name: "current-organization",
    component: () => import("../presentation/pages/CurrentOrganization.vue"),
    meta: {
      action: "view",
      subject: "organization",
      layout: "default",
    },
  },
  {
    path: "/organizations/pending",
    name: "pending-organizations",
    component: () => import("../presentation/pages/PendingOrganizations.vue"),
    meta: {
      action: "approve",
      subject: "organization",
      layout: "default",
    },
  },
  {
    path: "/organizations/subordinates",
    name: "subordinate-organizations",
    component: () => import("../presentation/pages/Subordinates.vue"),
    meta: {
      action: "list",
      subject: "organization",
      layout: "default",
    },
  },
  {
    path: "/organizations/all",
    name: "all-organizations",
    component: () => import("../presentation/pages/AllOrganizations.vue"),
    meta: {
      action: "list_all",
      subject: "organization",
      layout: "default",
    },
  },
  {
    path: "/organizations/partnerships",
    name: "partner-organizations",
    component: () => import("../presentation/pages/PartnerOrganizations.vue"),
    meta: {
      action: "list",
      subject: "organization_partnership",
      layout: "default",
    },
  },
  {
    path: "/organizations/:id",
    name: "organization-details",
    component: () => import("../presentation/pages/OrganizationDetails.vue"),
    meta: {
      action: "view",
      subject: "organization",
      layout: "default",
    },
  },
];
